(function ($) {
    $.fn.isInViewportWithOffset = function (scrollTop, scrollBottom, _offset, _clientHeight) {
        var el = jQuery(this);
        var elementTop = el.offset().top;
        var elementBottom = elementTop + el.outerHeight();
        var offset = _clientHeight * _offset;
        var viewportTop = scrollTop + offset;
        var viewportBottom = scrollBottom - offset;
        return viewportBottom > elementTop;
    };

    function initNavMobile() {
        $('.navmain li').each(function() {
            var item = $(this);
            var drop = item.find('.dropdown');
            var link = item.find('a').eq(0);
            if(drop.length) {
                item.addClass('hasdrop');
                if(link.length) link.addClass('hasdrop-a');
            }
        });

        var win = $(window),
            opener = $('.hasdrop-a'),
            drop = opener.siblings('.dropdown').hide(),
            hasDrop = $('.hasdrop'),
            dropParent;

        opener.click(function(){
            dropParent = $(this).closest('.navmain > ul > li');
            dropParent.siblings().find('.dropdown').slideUp(300);
            dropParent.siblings().removeClass('drop-active');
            dropParent.find('.dropdown').slideToggle(300);
            dropParent.toggleClass('drop-active');

            return false;
        });

        $('.hasdrop.drop-active .dropdown').show();

        $('.navmain-trigger').click(function() {
            $('body').removeClass('signup-active');
            $('body').toggleClass('navmain-active');
            return false;
        });

        $('.partner-sticky-header .links a').click(function() {
            $('body').removeClass('navmain-active');
        });
    }

    function initModal() {
        $('[data-toggle="modal"]').on('click', function() {
            var el = $(this);

            if($('body').hasClass('ab-contact-page') && el.attr('href') === '#modal-contact'){
                window.location.href = window.location.protocol + '//' + window.location.host + "/contact-us/sales/";
                return false;
            }

            if(el.hasClass('partner-fill-email')){
                var parent = $(this).parents('.input-addon'),
                    email = parent.find('input[type=email]'),
                    emailVal = email.val(),
                    validEmail = /(.+)@(.+){2,}\.(.+){2,}/.test(emailVal);

                if (!validEmail) {
                    parent.addClass('error');

                    email.keyup(function() {
                        parent.removeClass('error');
                    });
                    return;
                }

                parent.removeClass('error');
                $(el.attr('href')).find('#Email').val(emailVal);
            }

            $('body').addClass('modal-active');
            $('.modal').removeClass('show');
            $(el.attr('href')).addClass('show');
            return false;
        });

        $('.modal .close, [data-toggle="modal-close"]').on('click', function() {
            $('body').removeClass('modal-active');
            $('.modal').removeClass('show');
            return false;
        });

        $('.video-popup-opener .video-container').on('click', function (e) {
            e.preventDefault();
            var el = $(this),
                root = el.parent(),
                modal = root.find('.video-modal-window'),
                file = root.data('videoFile');

            modal.html('<div class="video-modal-wrap"><div class="video-modal-inner"><video controls><source src="'+file+'" type="video/mp4"></video><a class="video-close"></a></div></div>');
            $('body').addClass('video-active');
            setTimeout(function () {
                var video = modal.find('video');
                video.get(0).play();
            }, 100);

            modal.on('click', function () {
                modal.children().remove();
                $('body').removeClass('video-active');
            });

            modal.find('.video-close').on('click', function () {
                modal.children().remove();
                $('body').removeClass('video-active');
            });
        });
    }

    function initSlick() {
        var pr_slider = $('.press-releases-list');
        if(pr_slider.length){
            pr_slider.each(function () {
                var el = $(this);
                el.slick({
                    dots: true,
                    dotsClass: 'slick-dots',
                    rows: 3,
                    slidesPerRow: 3,
                    arrows: true,
                    appendDots: el.parent().find('.pagination .dots'),
                    appendArrows: $("<div class='arrows'></div>").appendTo(el.parent().find('.news-paging')),
                    nextArrow: '<button class="slick-next"></button>',
                    prevArrow: '<button class="slick-prev"></button>',
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                rows: 2,
                                slidesPerRow: 2,
                            }
                        },
                        {
                            breakpoint: 580,
                            settings: {
                                dots: false,
                                rows: 2,
                                slidesPerRow: 1,
                                // slidesToShow: 1,
                                // slidesToScroll: 1
                            }
                        }
                    ]
                })
            });
        }

        var workSlider = $('.work-carousel');
        workSlider.slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 11000,
            dots: true,
            arrows: false,
            pauseOnHover: false,
            adaptiveHeight: true,
            mobileFirst: true,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: true,
                        appendArrows: '.arrows-wrap',
                        dotsClass: 'work-dots',
                        appendDots: '.slick-nav .inner',
                        customPaging : function(slider, i) {
                            var title = $(slider.$slides[i]).data('title');
                            return '<i></i><div><span>'+title+' </span></div>';
                        },
                    }
                }]
        });

        function sliderStop() {
            workSlider.slick('slickPause');
            workSlider.parent().addClass('completed');
        }

        $('.work-carousel-wrap').on('click', '.work-dots li, .slick-arrow', function () {
            sliderStop();
        });

        $('.featured-carousel').slick({
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            appendArrows: '.navigation-wrap',
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                    }
                }
            ]
        });

        $('.slideshow')
            .after('<div class="arrow-wrap"></div>')
            .slick({
                dots: true,
                appendArrows: '.arrow-wrap',
                adaptiveHeight: true,
            });

        $('.quote-carousel').slick({
            fade: true,
            cssEase: 'linear',
            responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    dots: true,
                    arrows: false
                  }
                }
            ]
        });

        $('.leadership-slider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            swipeToSlide: true,
            dots: false,
            arrows: true,
            adaptiveHeight: true,
            infinite: false,

            responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: "unslick"
            },
            ]
        });

        $('.awards-slider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            swipeToSlide: true,
            dots: false,
            arrows: true,
            adaptiveHeight: true,

            responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: "unslick"
            },
            ]
        });

        $('.watch-slider').slick({
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            swipeToSlide: true,
            dots: false,
            arrows: true,

            responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            },
            ]
        });

        $('.upcoming-slider').slick({
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 2,
            swipeToSlide: true,
            dots: false,
            arrows: true,

            responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            },
            ]
        });

        $('.mobile-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            swipeToSlide: true,
            dots: true,
            arrows: false,
            mobileFirst: true,
            adaptiveHeight: true,

            responsive: [
            {
                breakpoint: 769,
                settings: 'unslick'
            },
            ]
        });

        $('.watch-slider-wrap, .upcoming-slider-wrap').each(function() {
            var item = $(this),
            win = $(window);
            var arrowTop = function() {
                var imgHeight = item.find('.video-hold').outerHeight(),
                arrow = item.find('.slick-arrow');
                arrow.css('top', ((imgHeight/2) - 13));
            }
            arrowTop();
            win.on('resize orientationchange load', arrowTop);
        });

        $(window).on('resize orientationchange', function() {
            $('.leadership-slider').slick('resize');
            $('.awards-slider').slick('resize');
        });

        var holder = $('.slider-network');
        if(holder.length){
            holder.each(function() {
                var el = $(this);
                var arrows = ($(el).data('arrowsPosition') === 'bottom') ? $("<div class='group-arrow group-arrow-bottom'></div>").appendTo(el.parent()) : ( ($(el).data('arrowsPosition') === 'header') ? $("<div class='group-arrow group-arrow-bottom'></div>").appendTo(el.parent().find('.slider-header')) : $("<div class='group-arrow'></div>").appendTo(el.prev()));

                el.slick({
                    dots: true,
                    infinite: true,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    swipeToSlide: true,
                    appendArrows: arrows,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            }
                        }
                    ]
                });
            });
        }

        $('.consolidate-slider').slick({
            // infinite: false
        });

        // slick mobile
        var win = jQuery(window);
        jQuery('[data-slick-phone]').each(function() {
            var holder = jQuery(this);
            var holderClasses = holder.attr('class');
            var holderHtml = holder.html();
            var mode = null;
            var refresh = function() {
                switch(mode) {
                    case 'desktop':
                    holder.attr('class',holderClasses)
                    .html(holderHtml);
                    break;
                    case 'mobile':
                    holder.slick({
                        slidesToScroll: 1,
                        rows: 0,
                        arrows: false,
                        dots: true,
                        dotsClass: 'slick-dots',
                        adaptiveHeight: true,
                        infinite: true,
                        autoplay: false
                    });
                    break;
                }
            };
            var resizeHandler = function() {
                if (window.innerWidth > 767) {
                    if (mode !== 'desktop') {
                        mode = 'desktop';
                        refresh();
                    }
                } else {
                    if (mode !== 'mobile') {
                        mode = 'mobile';
                        refresh();
                    }
                }
            };
            win.on('resize orientationchange', resizeHandler);
            resizeHandler();
        });
    }

    // nice select
    function initNiceSelect() {
        jQuery('[data-type="select"]').each(function(){
            var holder = jQuery(this),
                selectDrop = holder.find('ul'),
                linkItems = selectDrop.find('a'),
                selectOpener = holder.find('.opener'),
                activeClass = 'select--active';

            selectOpener.on('click', function(e) {
                e.preventDefault();
                holder.toggleClass(activeClass);
            });

            jQuery('html').on('click touchstart pointerdown MSPointerDown', function(e) {
                var target = jQuery(e.target);
                if(!target.closest(selectOpener).length && !target.closest(selectDrop).length) {
                    holder.removeClass(activeClass);
                }
            });


            linkItems.on('click', function(e) {
               if(!jQuery(this).hasClass('nice-select-active-link')){
                   e.preventDefault();
               }
                selectOpener.html(jQuery(this).html());
                holder.removeClass(activeClass);
                selectDrop.find('li a').removeClass('active');
                jQuery(this).addClass('active');
                if('filterLocation' in $(this).data()) {
                    filterJobLocation($(this).data('filterLocation'));
                }
            });

            selectOpener.html(selectDrop.find('.active').html());

        });
    }

    function sameHeight() {
        jQuery('.js-height').sameHeight({
            elements: '.js-h1',
            flexible: true,
            multiLine: true
        });
        jQuery('.js-height').sameHeight({
            elements: '.js-h2',
            flexible: true,
            multiLine: true
        });
        jQuery('.js-height').sameHeight({
            elements: '.js-h3',
            flexible: true,
            multiLine: true
        });
    }

    // initialize sticky blocks on scroll
    function initStickyScrollBlock() {
        jQuery('.sticky-block').stickyScrollBlock({
            container: '.press-row'
        });

        jQuery('.social-networks').stickyScrollBlock({
            container: '.inner'
        });

        jQuery('.nav-row').stickyScrollBlock({
            container: '.pm-hub-page',
            setBoxHeight: true,
            activeClass: 'fixed-position',
            positionType: 'fixed',
            extraTop: function() {
                var totalHeight = 0;
                totalHeight = (jQuery('.header-v3').outerHeight());
                return totalHeight;
             }
        });
    }

    /* Customers Page */

    function updateCustomStories(page, pagingType) {

        if(typeof page === 'undefined'){
            page = 1;
        }

        var role = $('#filter-role option:selected').val();
        var feature = $('#filter-feature option:selected').val();
        var industry = $('#filter-industry option:selected').val();
        var region = $('#filter-region option:selected').val();
        var pagination;
        var activeFilters = [];

        var request = {
            action: 'fetch_stories',
            page: page,
            page_id: $('.stories-content').data('customerPageId')
        };
        if (typeof feature !== 'undefined' && feature !== ''){
            request.feature = feature;
            activeFilters.push(feature);
        }
        if (typeof industry !== 'undefined' && industry !== ''){
            request.industry = industry;
            activeFilters.push(industry);
        }
        if (typeof role !== 'undefined' && role !== ''){
            request.role = role;
            activeFilters.push(role);
        }
        if (typeof region !== 'undefined' && region !== ''){
            request.region = region;
            activeFilters.push(region);
        }
        $('.stories-content .loading-spinner').css({
            display: 'block'
        });
        $('.stories-content .cards-list').css({
            display: 'none'
        });
        $('.stories-content .no-results').css({
            display: 'none'
        });

        if(activeFilters.length) {
            location.hash = activeFilters.join('&');
        } else {
            var uri = window.location.toString();
            if (uri.indexOf("#") > 0) {
                var clean_uri = uri.substring(0, uri.indexOf("#"))
                window.history.replaceState({}, document.title, clean_uri)
            }
        }

        $.get('/wp-admin/admin-ajax.php',
            request,
            function (response) {
                if(response.status === 'success'){
                    var parent = $('.stories-content .cards-list');
                    if(parent.length){
                        parent.empty();

                        // updateCustomerStoriesFilters(response.filters);

                        if(response.posts.length > 0){
                            response.posts.forEach(function (item) {
                                var root = $('<div class="col-sm-6 col-md-4"></div>');
                                var box = $('<a class="card-a-customer"/>')
                                    .attr('href', item.permalink);

                                var img = $('<div class="img"></div>');

                                if(item.is_fallback){
                                    img
                                        .addClass('is-logo');

                                    $('<img class="image-logo"/>')
                                        .attr('src', item.image)
                                        .appendTo(img);
                                } else {
                                    img.css({
                                        'background-image': 'url('+item.image+')'
                                    });
                                }
                                var cta_label = (item.link_label) ? item.link_label :'Read full story';
                                var holder = $('<div class="body"/>');
                                var header = $('<h3 class="h5 js-h1"/>')
                                    .text(item.title);
                                var content = $('<p class="js-h2">').text(item.content);
                                var link = $('<span/>')
                                    .addClass('more')
                                    .text(cta_label);
                                holder
                                    .append(header)
                                    .append(content)
                                    .append(link);

                                box
                                    .append(img)
                                    .append(holder)
                                    .appendTo(root);

                                parent.append(root);
                            });

                            parent.removeAttr('style');
                        } else {
                            $('.stories-content .no-results').css({
                                display: 'block'
                            });
                        }
                    }

                    if(pagingType === 'dots') {
                        pagination = $('.stories-content .slick-dots');
                        if(pagination.length){
                            pagination.empty();
                            if(response.pages > 1) {
                                for(var i = 1; i <= response.pages; i++){
                                    var li = $('<li/>');
                                    if(i == response.page){
                                        li.addClass('active');
                                    }
                                    $('<a/>')
                                        .attr('href', '#')
                                        .addClass('dot')
                                        .attr('data-story-page', i)
                                        .appendTo(li);
                                    li.appendTo(pagination);
                                }
                            }
                        }
                    } else {
                        pagination = $('.stories-content .stories-paging');
                        if(pagination.length && response.pages > 1) {
                            var prevBtn = pagination.find('a').first(),
                                nextBtn = pagination.find('a').last();

                            pagination.show();
                            if(page <= 1) {
                                prevBtn.hide();
                            } else {
                                prevBtn.show();
                            }

                            if(page >= response.pages) {
                                nextBtn.hide();
                            } else {
                                nextBtn.show();
                            }

                            pagination.find('.current-page').text(page);
                            pagination.find('.total-page').text(response.pages);
                            prevBtn.attr('data-story-page', page - 1 );
                            nextBtn.attr('data-story-page', parseInt(page) + 1);

                        } else {
                            pagination.hide();
                        }
                    }

                    $('.stories-content .loading-spinner').css({
                        display: 'none'
                    });

                    $('.stories-content').sameHeight({
                        elements: '.js-h2',
                        flexible: true,
                        multiLine: true
                    });
                    $('.stories-content').sameHeight({
                        elements: '.js-h3',
                        flexible: true,
                        multiLine: true
                    });
                    // equalheight('.stories-content .grid-item h3');
                    // equalheight('.stories-content .grid-item .text-equal');
                }
            });
    }

    function updateCustomerStoriesFilters(filters) {
        var role = $('#filter-role option');
        var feature = $('#filter-feature option');
        var industry = $('#filter-industry option');
        role.each(function(index, item) {
            var val = $(item).val();
            if(val.length > 0){
                if(filters['role'].indexOf(val) >= 0){
                    $(item).removeAttr('disabled');
                } else {
                    $(item).attr('disabled', 'disabled');
                }
            }
        });
        feature.each(function (index, item) {
            var val = $(item).val();
            if(val.length > 0){
                if(filters['feature'].indexOf(val) >= 0){
                    $(item).removeAttr('disabled');
                } else {
                    $(item).attr('disabled', 'disabled');
                }
            }
        });
        industry.each(function(index, item) {
            var val = $(item).val();
            if(val.length > 0){
                if(filters['industry'].indexOf(val) >= 0){
                    $(item).removeAttr('disabled');
                } else {
                    $(item).attr('disabled', 'disabled');
                }
            }
        });
    }

    function initCustomerStories() {
        if($('.stories-content').length){

            if(location.hash) {

                var activeFilters = location.hash.replace('#', '').split('&');

                $('.stories-content option').each(function(index, el) {
                    if(activeFilters.includes(el.value)) {
                        var select = $(el).parents('select');
                        select.val(el.value);
                    }
                });
                updateCustomStories(1);
            }

            $('.stories-content .select-wrap select').on('change', function(){
                updateCustomStories(1);
            });

            $('.stories-content .slick-dots').on('click', 'a', function (e) {
                e.preventDefault();
                var el = $(this);
                updateCustomStories(el.data('story-page'),'dots');
            });

            $('.stories-content .stories-paging').on('click', 'a', function (e) {
                e.preventDefault();
                var el = $(this);
                updateCustomStories(el.attr('data-story-page'),'simple');
            });

            $('.stories-content').on('click', '.reset-filter', function (e) {
                e.preventDefault();
                $('#filter-role').prop('selectedIndex',0);
                $('#filter-feature').prop('selectedIndex',0);
                $('#filter-industry').prop('selectedIndex',0);
                $('#filter-region').prop('selectedIndex',0);
                updateCustomStories(1);
            });

            // equalheight('.stories-content .grid-item h3');
            // equalheight('.stories-content .grid-item .text-equal');

        }
    }

    /* Customers Page End */

    function initTabs() {
        jQuery('.tabset, .js-tabset').tabset({
            tabLinks: 'a',
            defaultTab: true
        });

        jQuery('.tabs-list').tabset({
            tabLinks: 'a',
            defaultTab: true
        });
    }

    function initAnnouncementBanner() {
        if ($('.announcement-banner-wrap .promo-banner').length && Cookies.get($('.announcement-banner-wrap .promo-banner').data('banner')) != 1){
            $('.announcement-banner-wrap').css({
                display:'block'
            });

            $('body').addClass('announcement-banner-enabled');
        }
        if($('.promo-banner.banner-only-once').length) {
            var bannerName = $('.promo-banner.banner-only-once').data('banner');
            Cookies.set(bannerName, '1');
        }

        $('.announcement-banner-wrap .promo-banner a').on('click', function (e) {
            var el = $(this).parents('.promo-banner'),
                bannerName = el.data('banner');
            Cookies.set(bannerName, '1');
        });

        $('.announcement-banner-wrap .promo-banner .close-button').on('click', function (e) {
            e.preventDefault();
            Cookies.set($('.announcement-banner-wrap .promo-banner').data('banner'), 1);
            $('.announcement-banner-wrap .promo-banner').css({
                display:'none'
            });
            $('body').removeClass('announcement-banner-enabled');
        });

        if ($('.announcement-banner-wrap--optional .promo-banner--optional').length) {
            const banners = $('.announcement-banner-wrap--optional .promo-banner--optional');

            banners.each(function () {
                const cookie_key = $(this).data('banner');

                if (Number(Cookies.get(cookie_key)) !== 1) {
                    $(this).addClass('promo-banner--show');
                }
            });

            $('body').addClass('announcement-banner-enabled');
        }
    }

    function initFixedHeader() {
        if($('body').hasClass('nav-hidden')) return false;
        if($('body').hasClass('nav-fixed')) {
            jQuery('.header-new').addClass('header-sticky').addClass('header-visible');
            return false;
        }
        var lastScroll = jQuery(window).scrollTop();
        jQuery(window).on('scroll', function (e) {
            if (jQuery('body').hasClass('navmain-active') && window.innerWidth < 1024) return;
            var win = jQuery(window),
                currentScroll = win.scrollTop(),
                header = jQuery('.header-new'),
                promo  = jQuery('.promo-banner-wrap');

            var pheight = promo.length ? promo.outerHeight() : 0;

            if (currentScroll > lastScroll){
                if (currentScroll > pheight){
                    header.addClass('header-sticky');
                    if ((header).hasClass('header-visible')){
                        header.removeClass('header-visible');
                    }
                }
            } else {
                if (currentScroll < lastScroll){
                    header.addClass('header-sticky').addClass('header-visible');

                    if (currentScroll <= pheight) {
                        header.removeClass('header-sticky header-visible');
                    }
                }
            }
            lastScroll = currentScroll;
        });
        jQuery(window).scroll();
    }

    window.animations = window.animations || {};

    animations = {
        latestKnownScrollY: 0,
        ticking: false,
        preventAppearingAnimation: false,
        cache: {
            $html   : $('html'),
            $body   : $(document.body),
            $window : $(window),
        },
        init: function() {
            this.recalcWindow();
            this.initParallax();
            this.initParallaxVertical();
            this.initHeroAnimations();
            this.initAppearingAnimation();
            this.initNavSidebar();
            this.onResize();
            this.initListeners();
            this.initGoTo();
        },
        recalcWindow: function() {
            this.cache.mediaWidth = window.innerWidth;
            this.cache.clientWidth = this.cache.$window.width();
            this.cache.clientHeight = this.cache.$window.height();
        },
        onResize: function(){
            var self = this;
            this.recalcWindow();
            if(typeof this.navSidebar !== 'undefined' && typeof this.navSidebar.lines !== 'undefined' && this.navSidebar.lines.length > 1) {
                /*this.navSidebar.lines.each(function(idx, item) {
                    $(item).css({
                        height: self.cache.clientHeight * 0.6 / self.navSidebar.lines.length
                    });
                })*/
                this.navSidebar.sectionsBox = [];
                this.navSidebar.items.each(function(idx, item) {
                    var el = $(item),
                        box = {
                            el: el,
                            top: el.offset().top,
                            height: el.outerHeight(),
                            bottom: el.offset().top + el.outerHeight()
                        };
                    self.navSidebar.sectionsBox.push(box);
                });
            };
        },
        initListeners: function() {
            this.cache.$window.on('resize', this.onResize.bind(this));
            this.cache.$window.on('scroll', this.onScroll.bind(this)).scroll();
        },
        initNavSidebar: function() {
            var self = this;

            if ($('.media-service-wrap .nav-top-sticky .dot').length > 1){
                this.navSidebar = {
                    dots: $('.media-service-wrap .nav-top-sticky .dot'),
                    lines: $('.media-service-wrap .nav-top-sticky .dot .dot-line'),
                    linesInner: $('.media-service-wrap .nav-top-sticky .dot .dot-line--inner'),
                    wrapper: $('.media-service-wrap'),
                    items: $('.media-service-wrap .media-service'),
                    count: $('.media-service-wrap .nav-top-sticky .dot').length
                }
            }

            if($('#team-media-section').length){
                var type = window.location.hash.substr(1);
                setTimeout(function (e) {
                    var idx = $('#'+type).data('teamSection'),
                        pos = self.navSidebar.wrapper.offset().top;
                    var delta = (idx - 1) * self.cache.clientHeight * 1.5;
                    $('html, body').animate({
                        scrollTop: pos + delta
                    }, 700);
                }, 10);
            }

            $('[data-team-slide]').on('click', function (e) {
                e.preventDefault();
                var el = $(this),
                    idx = el.data('teamSlide'),
                    pos = self.navSidebar.wrapper.offset().top;
                var delta = (idx - 1) * self.cache.clientHeight * 1.5;
                $('html, body').animate({
                    scrollTop: pos + delta
                }, 700);
            });
        },
        initAppearingAnimation: function(){
            var self = this;

            this.appearingBlocks = $('[data-appear-block]');
            this.appearingBlocksLimit = $('[data-appear-block-limit]');
            this.appearingGroups = $('[data-appear-group]');
            this.appearingCommons = $('[data-appear-text], [data-appear-text-group], [data-appear-fade-in], [data-med-header]');


            if (this.appearingBlocks.length) {
                this.appearingBlocks.each(function () {
                    var el = $(this),
                        delay = (parseFloat(el.data('animationDelay')) >= 0) ? parseFloat(el.data('animationDelay')) : 0.15;
                    el.find('> *').each(function (index) {
                        var item = $(this);
                        if (index > 0) {
                            item
                                .attr('data-transition-delay', (index * delay) + 's')
                                .css({
                                    '-webkit-transition-delay': (index * delay) + 's',
                                    'transition-delay': (index * delay) + 's'
                                });
                        }
                    });
                });
            }

            if (this.appearingBlocksLimit.length) {
                this.appearingBlocksLimit.each(function () {
                    var el = $(this),
                        delay = (parseFloat(el.data('animationDelay')) >= 0) ? parseFloat(el.data('animationDelay')) : 0.15;
                    el.find('> *').each(function (index) {
                        var item = $(this);
                        if (index > 0 && index < 6) {
                            item
                                .attr('data-transition-delay', (index * delay) + 's')
                                .css({
                                    '-webkit-transition-delay': (index * delay) + 's',
                                    'transition-delay': (index * delay) + 's'
                                });
                        }
                    });
                });
            }

            if (this.appearingGroups.length) {
                this.appearingGroups.each(function () {
                    var el = $(this),
                        initDelay = (parseFloat(el.data('animationInitDelay')) >= 0) ? parseFloat(el.data('animationInitDelay')) : 0,
                        delay = (parseFloat(el.data('animationDelay')) >= 0) ? parseFloat(el.data('animationDelay')) : 0.15;
                    el.find('[data-appear-group-item]').each(function (index) {
                        var item = $(this),
                            delayVal = ((index * delay) + initDelay) + 's';
                        item
                            .attr('data-transition-delay', delayVal)
                            .css({
                                'transition-delay': delayVal
                            });
                    });
                });
            }

            this.cache.$window.scroll();
        },
        initParallax: function () {
            $('[data-parallax-item]').paroller({
                type: 'foreground'
            });
        },
        initParallaxVertical: function () {
            if($('[data-scroll-parallax-vertical]').length === 0) return false;
            this.parallaxVertical = [];
            var parallaxVertical = $('[data-scroll-parallax-vertical]');
            var self = this;
            parallaxVertical.each(function () {
                var el = $(this);
                var elem = {
                    el: el,
                    inner: el.children(),
                    direction: ('opposite' === el.data('scrollParallaxVertical')) ? -1 : 1
                };
                self.parallaxVertical.push(elem);
            });
        },
        initHeroAnimations: function () {
            var jsHeroTitle = jQuery('.js-hero .js-title');
            if (jsHeroTitle.length === 0) return false;

            var self = this;
            self.preventAppearingAnimation = this.cache.$window.scrollTop() < 100;

            if(!jsHeroTitle.hasClass('js-title-image')) {
                var heroTitleSplitText = new SplitText(".js-hero .js-title", {type: "words", wordsClass: 'js-letter'}),
                    heroTitleChars = heroTitleSplitText.words;

                heroTitleChars.forEach(function (t) {
                    return t.innerHTML = '<div class="js-inner">' + t.innerHTML + "</div>"
                });

                var heroTitleLetters = jQuery('.js-hero .js-title .js-inner');
            }

            setTimeout(function () {
                jQuery(".js-hero .js-hero-content").addClass('visible');
                var completedAnimation = false;
                var completeEdge = $('.js-hero-image').length > 0 ? 0.8 : 0.5;
                var timeline = new TimelineMax({
                    onUpdate: function () {
                        if(this.progress() > completeEdge && !completedAnimation){
                            completedAnimation = true;
                            self.preventAppearingAnimation = false;
                            self.cache.$window.scroll();
                        }
                    }
                })
                    .to('.js-hero .js-subtitle', 1.1, {opacity: 1, y: 0, ease: Expo.easeOut});

                if(!jsHeroTitle.hasClass('js-title-image')) {
                    timeline
                        .staggerTo(heroTitleLetters, 1.5, {y: "0%", ease: Expo.easeOut}, .06, "-=0.8");
                } else {
                    timeline
                        .to(jsHeroTitle, 1.5, {opacity: 1, y: "0%", ease: Expo.easeOut}, "-=0.8");
                }
                timeline
                    .staggerTo('.js-hero .js-copy', 1.1, {opacity: 1, y: 0, ease: Expo.easeOut}, .3, "-=0.8")
                    .fromTo('[data-decor-fly]', 1.1, {opacity: 0, y: 20}, {opacity: 1, y: 0, ease: Expo.easeOut}, "-=0.8")
                    .fromTo('.js-hero-image', 1.1, {opacity: 0, y: 20}, {opacity: 1, y: 0, ease: Expo.easeOut}, "-=0.8")
                ;
            }, 250);
        },
        requestTick: function() {
            if(!this.ticking) {
                requestAnimationFrame(this.update.bind(this));
            }
            this.ticking = true;
        },
        onScroll: function () {
            this.latestKnownScrollY = this.cache.$window.scrollTop();
            this.requestTick();
        },
        update: function() {
            var self = this;
            this.ticking = false;
            var scrollTop = this.latestKnownScrollY;
            var scrollBottom = this.latestKnownScrollY + this.cache.clientHeight;
            var scrollMiddle = this.latestKnownScrollY + (this.cache.clientHeight / 2);

            /* Appearing Animations*/
            var appearOffsetDefault = 0.05;

            if(!this.preventAppearingAnimation){
                if(typeof this.appearingBlocks !== 'undefined' && this.appearingBlocks.length){
                    this.appearingBlocks.not('.is-appeared').each(function (index, item) {
                        var el = $(item),
                            appearOffset = (typeof el.data('appearOffset') !== 'undefined') ? el.data('appearOffset') : appearOffsetDefault;

                        if (el.isInViewportWithOffset(scrollTop, scrollBottom, appearOffset, self.cache.clientHeight)) {
                            el.addClass('is-appeared');
                        }
                    });
                }

                if(typeof this.appearingBlocksLimit !== 'undefined' && this.appearingBlocksLimit.length){
                    this.appearingBlocksLimit.not('.is-appeared').each(function (index, item) {
                        var el = $(item),
                            appearOffset = (typeof el.data('appearOffset') !== 'undefined') ? el.data('appearOffset') : 0.05;

                        if (el.isInViewportWithOffset(scrollTop, scrollBottom, appearOffset, self.cache.clientHeight)) {
                            el.addClass('is-appeared');
                        }
                    });
                }

                if(typeof this.appearingGroups !== 'undefined' && this.appearingGroups.length){
                    this.appearingGroups.not('.is-appeared').each(function (index, item) {
                        var el = $(item),
                            appearOffset = (typeof el.data('appearOffset') !== 'undefined') ? el.data('appearOffset') : appearOffsetDefault;

                        if (el.isInViewportWithOffset(scrollTop, scrollBottom, appearOffset, self.cache.clientHeight)) {
                            el.addClass('is-appeared');
                        }
                    });
                }

                if(typeof this.appearingCommons !== 'undefined' && this.appearingCommons.length){
                    this.appearingCommons.not('.is-appeared').each(function (index, item) {
                        var el = $(item),
                            appearOffset = (typeof el.data('appearOffset') !== 'undefined') ? el.data('appearOffset') : appearOffsetDefault;
                        if (el.isInViewportWithOffset(scrollTop, scrollBottom, appearOffset, self.cache.clientHeight)) {
                            el.addClass('is-appeared');
                        }
                    });
                }
            }

            /* Appearing Animations END*/

            /////////////////////////////////////////////
            // Sidebar scroll indicator on Teams page
            if(typeof this.navSidebar !== 'undefined' && typeof this.navSidebar.dots !== 'undefined' && this.navSidebar.dots.length > 1){
                this.navSidebar.wrapperHeight = this.navSidebar.wrapper.height();
                this.navSidebar.lastSectionHeight = this.navSidebar.items.eq(this.navSidebar.items.length).height();
                this.navSidebar.wrapperTop = this.navSidebar.wrapper.offset().top;
                var gap = this.cache.clientHeight * 0.7;
                var scrollPercent = Math.max(Math.min((scrollTop - this.navSidebar.wrapperTop) / (this.navSidebar.wrapperHeight - this.cache.clientHeight - gap), 1), 0);
                var sectionDelta = (1 / (this.navSidebar.count - 1));
                var currentSection = Math.floor(scrollPercent / sectionDelta);
                for(var i = 0; i < this.navSidebar.items.length; i++){
                    var scrollPos = 0;
                    if(currentSection > i){
                        scrollPos = 0
                    } else {
                        scrollPos = ((scrollPercent - (sectionDelta * i)) / sectionDelta) * 100;
                    }
                    if(this.navSidebar.linesInner.length){
                        this.navSidebar.linesInner.eq(i).css({
                            width: scrollPos + "%"
                        });
                    }
                }
                this.navSidebar.dots.removeClass('active');
                this.navSidebar.dots.eq(currentSection).addClass('active');
                this.navSidebar.items.removeClass('active');
                this.navSidebar.items.eq(currentSection).removeClass('prev').removeClass('next');
                this.navSidebar.items.eq(currentSection - 1).addClass('prev');
                this.navSidebar.items.eq(currentSection + 1).addClass('next');
                this.navSidebar.items.eq(currentSection).addClass('active');
            }

            /////////////////////////////////////////////
            // Vertical Parallax

            if(typeof this.parallaxVertical !== 'undefined' && this.parallaxVertical.length > 0) {
                for (var idx = 0; idx < this.parallaxVertical.length; idx++){
                    var posY = this.parallaxVertical[idx].el.offset().top;
                    var boundY = this.parallaxVertical[idx].el.get(0).getBoundingClientRect().y;
                    var delta = this.parallaxVertical[idx].direction * ((posY - boundY) / 30);
                    this.parallaxVertical[idx].inner.css({
                        '-webkit-transform': 'translate3d('+delta+'px, 0px, 0px)',
                        'webkit-transform': 'translate3d('+delta+'px, 0px, 0px)',
                    })
                }
            }

        },
        initGoTo: function() {
            this.link = $('[data-go-to]');
            if (this.link.length === 0) return false;
            this.link.click(function () {
                if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                    var target = jQuery(this.hash);
                    target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
                    if (target.length) {
                        jQuery('html, body').animate({
                            scrollTop: target.offset().top
                        }, 1000);
                        return false;
                    }
                }
            });
        }
    };

    function initRetinaBackground(){
        jQuery('.bg-stretch, .bg-fill').retinaCover();
    }

    function initAccordion() {
        $('[data-click="toggle"]').on('click', function(e){
            e.preventDefault();
            $(this).parent().hasClass('active') ? $(this).parent().removeClass('active') : $(this).parent().addClass('active');
        });

        var slideOpener = $('[data-click="slide"]');
        slideOpener.next().hide();
        slideOpener.parent('.active').find('.slide').show();
        slideOpener.on('click', function(e){
            e.preventDefault();
            $(this).parent().hasClass('active') ? $(this).parent().removeClass('active').find('.slide').slideUp() : $(this).parent().addClass('active').find('.slide').slideDown();
        });
    }

    function initToggle() {
        var dclass = jQuery('[data-click="menu-a"]').next().attr('class');
        jQuery('[data-click="menu-a"] a').click(function (e) {
            e.preventDefault();
            jQuery('[data-click="menu-a"] a').removeClass('active');
            jQuery('[data-click="menu-a"]').next().attr('class', dclass);
            $(this).hasClass('active') ? $(this).removeClass('active') : $(this).addClass('active');
            jQuery(this).parents('[data-click="menu-a"]').next().addClass(jQuery(this).text().toLowerCase());
        })
    }

    function initInineNav() {
        jQuery('.menu-inline').each(function () {
            var holder = jQuery(this);
            var tabset = holder.find('> ul');
            var linkItems = tabset.find('a');
            var tabOpener = holder.find('.filter-nav-opener');
            var activeClass = 'filter-active';

            tabOpener.on('click', function (e) {
                e.preventDefault();
                holder.toggleClass(activeClass);
            });

            jQuery('html').on('click', function (e) {
                var target = jQuery(e.target);
                if (!target.closest(tabOpener).length && !target.closest(tabset).length) {
                    holder.removeClass(activeClass);
                }
            });

            tabOpener.html(jQuery('.menu-inline .active a').html());

            linkItems.each(function () {
                jQuery(this)
                    .on('mouseenter', function (e) {
                        var gradient = '.ani-gradient .' + jQuery(this).data('gradient');
                        jQuery(gradient).css({
                            zIndex: 3,
                            opacity: 1
                        });
                    })
                    .on('mouseleave', function (e) {
                        var gradient = '.ani-gradient .' + jQuery(this).data('gradient');
                        jQuery(gradient).css({
                            zIndex: 1,
                            opacity: 0,
                        })
                    })
                    .on('click', function (e) {
                       if($(this).hasClass('separate-page')){
                            return true;
                       }
                        e.preventDefault();
                        holder.removeClass(activeClass);
                        var btn = $(this),
                            href = btn.attr('href'),
                            parent = btn.parent(),
                            legalContentBox = $('.legal-tab .box-tab'),
                            spinner = $('.load-spinner'),
                            animatedElements = $('.animate-queue');

                        jQuery('.page-title.ani-gradient').attr('data-gradient', btn.data('gradient'));

                        jQuery('.filter-legal ul li').removeClass('active');
                        parent.addClass('active');

                        animatedElements.animate({
                            opacity: 0
                        }, 200, function () {
                            animatedElements.removeClass('animated');
                            spinner.addClass('animate');

                            $.get(href, function (data) {
                                var html = $(data);
                                var content = html.find('.legal-tab .box-tab');

                                if (content) {
                                    setTimeout(function () {
                                        legalContentBox.html(content.clone().html());
                                        animatedElements
                                            .css({
                                                opacity: 1
                                            });
                                        spinner.removeClass('animate');
                                        animatedElements.addClass('animated')
                                    }, 300);
                                }
                            });
                        });

                        history.pushState(null, null, href);
                        return false;
                    });
            });

            jQuery('.page-title.ani-gradient').attr('data-gradient', jQuery('.menu-inline .active a').data('gradient'));
        });
    }

    function initSearchSlide() {
        var searchopener = jQuery('.search-opener'),
            searchwrap = jQuery('.search-form'),
            links = searchwrap.find('a'),
            searchactive = 'search-active';

        searchopener.click(function () {
            jQuery('body').toggleClass(searchactive);
        });

        links.click(function () {
            jQuery('body').removeClass(searchactive);
        });

        jQuery('html').on('click touchstart pointerdown MSPointerDown', function (e) {
            var target = jQuery(e.target);
            if (!target.closest(searchopener).length && !target.closest(searchwrap).length) {
                jQuery('body').removeClass(searchactive);
            }
        });

        var activateResizeHandler = function () {
            var win = $(window),
                doc = $('html'),
                resizeClass = 'resize-active',
                flag, timer;
            var removeClassHandler = function () {
                flag = false;
                doc.removeClass(resizeClass);
            };
            var resizeHandler = function () {
                if (!flag) {
                    flag = true;
                    doc.addClass(resizeClass);
                }
                clearTimeout(timer);
                timer = setTimeout(removeClassHandler, 500);
            };
            win.on('resize orientationchange', resizeHandler);
        };

        activateResizeHandler();
    }

    function initSignupSlide() {
        var signupopener = jQuery('.signup-opener'),
        signupwrap = jQuery('.signup-dropdown'),
        links = signupwrap.find('a'),
        signupactive = 'signup-active';

        signupopener.click(function() {
            jQuery('body').removeClass('navmain-active');
            jQuery('body').toggleClass(signupactive);
            event.preventDefault();
        });

        links.click(function() {
            jQuery('body').removeClass(signupactive);
        });

        jQuery('html').on('click touchstart pointerdown MSPointerDown', function(e) {
            var target = jQuery(e.target);
            if(!target.closest(signupopener).length && !target.closest(signupwrap).length) {
                jQuery('body').removeClass(signupactive);
            }
        });

        var activateResizeHandler = function() {
            var win = $(window),
            doc = $('html'),
            resizeClass = 'resize-active',
            flag, timer;
            var removeClassHandler = function() {
                flag = false;
                doc.removeClass(resizeClass);
            };
            var resizeHandler = function() {
                if(!flag) {
                    flag = true;
                    doc.addClass(resizeClass);
                }
                clearTimeout(timer);
                timer = setTimeout(removeClassHandler, 500);
            };
            win.on('resize orientationchange', resizeHandler);
        };

        activateResizeHandler();
    }

    function initTeamVprogress() {
        if ($('.media-service-sticky').length) {
            $('.media-service-sticky').stickyScrollBlock({
                container: '.media-service-wrap'
            });
        }
    }

    function initCheckAdBlocker() {
        $('<div/>')
            .css({
                display: 'none',
                width: '1px',
                height: '1px',
                position: 'absolute',
                left: 0,
                top: 0
            })
            .attr('id', 'check-adblock-pixel')
            .appendTo($('body'));
    }

    function initIndustryLogo() {
        var block = $('.industry-partners ul'),
            items = block.children().length;

            if(items <= 4) {
                block.addClass('col-2');
            } else {
                block.addClass('col-3');
            }

            if(items %2 == 0) {
                block.addClass('even');
            } else {
                block.addClass('odd');
            }

        $('.hero-industry').length ? $('.header-new').find('.btn-sign-up').addClass('btn-text-black') : false;
    }

    function filterJobLocation(filter) {
        $('.job-accordion > li').each(function () {
            var el = $(this);
            el.css({
                'display': 'block'
            });
            if(filter === 'all') {
                el.find('[data-job-location]').css({
                    'display': 'block'
                });
                return;
            }

            var filteredJobs = el.find('[data-job-location='+filter+']');
            if(filteredJobs.length === 0){
                el.css({
                    'display': 'none'
                });
            }
            el.find('[data-job-location]').css({
                'display': 'block'
            });
            el.find('[data-job-location]').not(filteredJobs).css({
                'display': 'none'
            });
        });
    }

    function initJobSearch() {
        $('#search-job').on('submit', function (e) {
            e.preventDefault();
            var form = $(this),
                input = form.find('input[type="search"]'),
                val = input.val().toLowerCase();

            if(val.length > 2){
                $('.job-accordion > li').each(function () {
                    var el = $(this);
                    el.css({
                        'display': 'block'
                    });
                    var filteredJobs = el.find('[data-job-title*="'+val+'"]');
                    if(filteredJobs.length === 0){
                        el.css({
                            'display': 'none'
                        });
                    }
                    el.find('[data-job-title]').css({
                        'display': 'block'
                    });
                    el.find('[data-job-title]').not(filteredJobs).css({
                        'display': 'none'
                    });
                });
            } else {
                $('.job-accordion > li').css({
                    'display': 'block'
                });
                $('[data-job-title]').css({
                    'display': 'block'
                });
            }
        })
    }

    function initServicesTab() {
        var activetab = jQuery('.services-tab .active a').attr('href');
        jQuery(activetab).addClass('active');

        jQuery('.services-tab a').click(function(){
            jQuery('.services-tab li').removeClass('active');
            jQuery(this).parent().addClass('active');
            jQuery('.services-list > div').removeClass('active');
            var currentTab = jQuery(this).attr('href');
            jQuery(currentTab).addClass('active');
            return false;
        });

        jQuery('.service-list-item').click(function (e) {
            e.preventDefault();
            var el = jQuery(this);
            if (!(el.hasClass('active'))){
                jQuery('.services-tab a[data-link='+el.attr('id')+']').click();
            }
        })
    }

    function initFocusClass() {
        var $input = jQuery('[data-focus]');
        $input
            .on('focus', function () {
                $input.parent().addClass('has-focus');
            })
            .on('blur', function () {
                if (!$input.val()) {
                    $input.parent().removeClass('has-focus');
                }
            });
    }

    function convertTimeZone() {
        if($('[data-time-convert]').length) {
            $('[data-time-convert]').each(function () {
                var el = $(this);
                var currentDate = el.data('timeConvert');
                var timeZone = el.data('timeZone');
                var timeZoneIANA = timeZone || 'America/Chicago';
                var eventDate = moment.tz(currentDate, timeZoneIANA);
                var localTZ = moment.tz.guess();
                var result = eventDate.local().format('MMMM Do h:mm a').toString() + " " +  moment.tz(localTZ).zoneAbbr();
                el.text(result);
            });
        }
    }

    function InlineHeaderSVG () {
        $('.header-v3 .inline-svg').each(function () {
            var img = $(this);
            if (img.length > 0) {
                $.get(img[0].src, function (svgDoc) {
                    var importedSVGRootElement = document.importNode(svgDoc.documentElement, true);
                    if (img.hasClass('no-fill')) {
                        img.parent().html(importedSVGRootElement);
                    } else {
                        img.parent().html(importedSVGRootElement).find('svg').addClass('fill-current');
                    }
                });
            }
        });
    }

    function FixedHeaderVersion3 () {
        if(! $('.header-v3').length) return;

        if($('body').hasClass('nav-hidden')) return false;
        if($('body').hasClass('nav-fixed')) {
            jQuery('.header-v3').addClass('header-sticky').addClass('header-visible');
            return false;
        }
        var lastScroll = jQuery(window).scrollTop();
        jQuery(window).on('scroll', function (e) {
            if (jQuery('body').hasClass('navmain-active') && window.innerWidth < 1024) return;
            var win = jQuery(window),
                currentScroll = win.scrollTop(),
                header = jQuery('.header-v3'),
                promo  = jQuery('.promo-banner-wrap');

            var pheight = promo.length ? promo.outerHeight() : 0;

            if (currentScroll > lastScroll){
                if (currentScroll > pheight){
                    header.addClass('header-sticky');
                    if ((header).hasClass('header-visible')){
                        header.removeClass('header-visible');
                    }
                }
            } else {
                if (currentScroll < lastScroll){
                    header.addClass('header-sticky').addClass('header-visible');

                    if (currentScroll <= pheight) {
                        header.removeClass('header-sticky header-visible');
                    }
                }
            }
            lastScroll = currentScroll;
        });
        jQuery(window).scroll();
    }

    function MobileNavVersion3 () {
        if(!$('.header-v3, .header-blog').length) return;

        var navopener = $('.navmain-opener'),
            navwrap   = $('.navmain'),
            links     = navwrap.find('a'),
            navactive = 'navmain-active';

        navopener.click(function(e) {
            e.preventDefault();
            $('body').toggleClass(navactive);
        });

        $('.navmain li').each(function() {
            var item = $(this);
            var drop = item.find('ul');
            var link = item.find('a').eq(0);
            if(drop.length) {
                item.addClass('hasdrop');
                if(link.length) link.addClass('hasdrop-a').attr({'data-more': '', 'data-outside': ''});
            }
        });

        links.click(function() {
            $(this).hasClass('hasdrop-a') ? false : $('body').removeClass(navactive);
        });

        $('html').on('click touchstart pointerdown MSPointerDown', function(e) {
            var target = $(e.target);
            if(!target.closest(navopener).length && !target.closest(navwrap).length) {
                $('body').removeClass(navactive);
            }
        });
    }

    function NavItemHoverVersion3 () {
        if(!$('.header-v3').length) return;

        jQuery('.navmain-drop-link').on('mouseover', function() {
            jQuery(this).parent().parent().parent().siblings().addClass('hovered')
            jQuery(this).parent().siblings().addClass('hovered')
        }).on('mouseout', function() {
            jQuery(this).parent().parent().parent().siblings().removeClass('hovered')
            jQuery(this).parent().siblings().removeClass('hovered')
        })
    }

    function NavToggleVersion3 () {
        if(!$('.header-v3').length) return;

        var dclass = jQuery('[data-click="menu-a"]').next().attr('class');
        jQuery('[data-click="menu-a"] a').click(function(e) {
            e.preventDefault();
            jQuery('[data-click="menu-a"] a').removeClass('menu-active');
            jQuery('[data-click="menu-a"]').next().attr('class', dclass);
            $(this).hasClass('menu-active') ? $(this).removeClass('menu-active') : $(this).addClass('menu-active');
            jQuery(this).parents('[data-click="menu-a"]').next().addClass(jQuery(this).text().toLowerCase());
        });
    }

    function initOpenClose() {
        $('[data-more]').next().hide();
        $('[data-more].active').next().show();

        $('[data-more]').click(function(e) {
            e.preventDefault();
            $(this).hasClass('active') ? $(this).removeClass('active').next().slideUp(200) : $(this).addClass('active').next().slideToggle(200);

            if($(this).closest('[data-accordion]').length) {
                $(this).parent().siblings().find('[data-more]').removeClass('active');
                $(this).parent().siblings().find('[data-more]').next().slideUp(200);
            }
        })

        $('[data-outside]').next().find('a:not(.hasdrop-a):not([data-more])').click(function() {
            $('[data-outside]').removeClass('active').next('').slideUp(200);
        });
        $('[data-outside]').click(function(e) {
            $('[data-outside]').not(this).removeClass('active').next().slideUp(200);
        });

        $('html').on('click touchstart pointerdown MSPointerDown', function(e) {
            var target = $(e.target);

            if(!(target.closest('[data-outside]').length) && !(target.closest('[data-outside] + *').length)) {
                setTimeout (function() {
                    $('[data-outside]').removeClass('active').next().slideUp(200);
                }, 200)
            }

            if(!(target.closest('[data-outside-1]').length) && !(target.closest('[data-outside-1] + *').length)) {
                setTimeout (function() {
                    $('[data-outside-1]').removeClass('active').next().slideUp(200);
                }, 200)
            }
        });
    }

    function MultipleSelectDrop() {
        var select = $('select[multiple]');
        var options = select.find('option:not(:first-child)');

        var div = $('<div />').addClass('selectMultiple');
        var list = $('<ul />');
        var placeholder = select.find('option').first();
        var active = $('<div />').addClass('opener');

        $('<span />').text(placeholder.text()).appendTo(active);

        options.each(function () {
            var text = $(this).text();
            list.append($('<li />').html(text));
        });

        div.append(active).append(list);
        select.wrap(div);

        $('.selectMultiple select').detach().prependTo('.selectMultiple');

        $(document).on('click', '.selectMultiple ul li', function (e) {
            var select = $(this).parent().parent();
            var li = $(this);
            if (!li.hasClass('selected')) {
                li.addClass('selected');
                select.find('option:contains(' + li.text() + ')').prop('selected', true);
            } else {
                li.removeClass('selected');
                select.find('option:contains(' + li.text() + ')').prop('selected', false);
            }
        });

        $(document).on('click', '.selectMultiple > .opener', function (e) {
            $(this).parent().toggleClass('open');
        });

        $('html').on('click touchstart pointerdown MSPointerDown', function (e) {
            var target = $(e.target);
            if (!target.closest('.selectMultiple').length) {
                $('.selectMultiple').removeClass('open');
            }
        });
    }

    function initTopNavTracker() {
        $('.navmain-drop [href*="testimonial.to/mixpanel/all"]').click(function(e){
            if(typeof ga === 'function') {
                e.preventDefault();
                const url = $(this).attr('href');

                ga('gtm4.send', 'event', 'outbound', 'click', url, {
                    'hitCallback': function(){document.location = url;}
                });

                setTimeout(function () {
                    document.location = url;
                }, 1000)
            }
        });
    }

    jQuery(document).ready(function($){
        initNavMobile();
        initModal();
        initNiceSelect();
        sameHeight();
        initSlick();
        initStickyScrollBlock();
        // initCustomerStories();
        initTabs();
        initFixedHeader();
        initRetinaBackground();
        initAnnouncementBanner();
        initInineNav();
        initTeamVprogress();
        animations.init();
        initSearchSlide();
        initSignupSlide();
        initAccordion();
        initToggle();
        initCheckAdBlocker();
        initFocusClass();
        initServicesTab();
        initJobSearch();
        initIndustryLogo();
        initCheckAdBlocker();
        initIndustryLogo();
        initServicesTab();
        convertTimeZone();
        InlineHeaderSVG();
        MobileNavVersion3();
        FixedHeaderVersion3();
        NavItemHoverVersion3();
        NavToggleVersion3();
        initOpenClose();
        initTopNavTracker();
    });

    if (typeof MktoForms2 !== 'undefined') {
        MktoForms2.whenReady(function (form) {
            MultipleSelectDrop();
        });
    }
})(jQuery);
